import { Badge, Button, Col, Form, Row, Select, Space } from "antd";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import {
  BASE_URL,
  GET_BATCH_COURSES_CHAPTER_VIEW,
  GLOBAL_SEARCH,
} from "utilFunctions/Constants/urlConstants";
import dayjs from "dayjs";
import { useGetApi } from "utilFunctions/CustomHooks/useGetAPI";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import HeadersComponent from "utilFunctions/shared/AntdSharedComponents/HeadersComponent";
import AutoSearchInput from "utilFunctions/shared/AutoSearchInput";
import { ToastContextDispatch } from "Context/CommonContext";
import DrawerAntdComponent from "utilFunctions/shared/AntdSharedComponents/DrawerAntdComponent";
import type { DatePickerProps } from "antd";
import { DatePicker } from "antd";
import ChipsTagsAntdComponent from "utilFunctions/shared/AntdSharedComponents/ChipsTagsAntdComponent";
import { removeEmptyFields } from "utilFunctions/helperFunctions/HelperFunction";
const monthFormat = "MMM-YYYY";
interface MyBatchesHeaderAntdIF {
  cardTitle: string;
  chapterData: any;
  setBatchesData: any;
  BatchesData: any;
  setChapterData: any;
  handleSearchFaculty: any;
  handleMonthYearFilter?: any;
  filterState?: any;
  setfilterState?: any;
  currentDate?: any;
}
export const StyledRow = styled<any>(Row)`
  width: ${({ screen }: any) =>
    ["xxl", "xl", "lg"].includes(screen) ? "100%" : "100%"};
  margin-top: ${({ screen }: any) =>
    ["xxl", "xl", "lg"].includes(screen) ? "" : "12px"};
`;
export const setChapterHandler = (batches: any, chapterList: any) => {
  const arr = batches.map((ele: any) => {
    const el = chapterList.find((el: any) => el.batchId === ele.batchId);
    if (el) {
      return { ...ele, chapterData: el };
    }
    return ele;
  });
  return arr;
};
const MyBatchesHeaderAntd = ({
  cardTitle,
  chapterData,
  setBatchesData,
  BatchesData,
  setChapterData,
  handleSearchFaculty,
  handleMonthYearFilter,
  filterState,
  setfilterState,
  currentDate,
}: MyBatchesHeaderAntdIF) => {
  const navigate = useNavigate();
  const ToastDispatch = useContext(ToastContextDispatch);
  const { screen }: any = useWindowSize();
  const [inputValue, setInputValue] = useState<string>("");
  const [suggestions, setSuggestions] = useState<any>([]);
  const [offset, setOffSet] = useState<number>(0);
  const [isLoader, setIsLoader] = useState<boolean>(false);
  const [searchURL, setSearchURL] = useState<string>("");
  const [hasMore, setHasMore] = useState<boolean>(false);
  const [searchName, setSearchName] = useState<any>();
  const [input, setInput] = useState("");
  const [limit] = useState<number>(10);
  const [selectedFaculty, setSelectedFaculty] = useState<any>(null);
  const [open, setOpen] = useState<boolean>(false);
  const [selectedValue, setSelectedValue] = useState("plannedLectures");
  const [dateNString, setdateNString] = useState<any>(currentDate);
  const defaultvalue: any = {
    email: null,
    plannedLecture: "plannedLectures",
    month: currentDate,
  };

  const { makeRequest: GetSearchData, responseData: searchData } = useGetApi(
    (data) => {
      onFetcheddata(data);
    },
    (error) => {
      onFetchError(error);
    }
  );
  const onFetcheddata = (data: any) => {
    setIsLoader(false);
    console.log(data);
  };
  const onFetchError = (error: any) => {
    console.log("erorr", error);
    setIsLoader(false);
    if (offset == 0) {
      // setSuggestions([]);
    } else {
      setOffSet(0);
    }
    setHasMore(false);
  };
  useEffect(() => {
    if (searchData && searchData != null) {
      if (offset == 0) {
        setSuggestions([...searchData["data"]]);
      } else {
        setSuggestions((previous: any) => [...previous, ...searchData["data"]]);
      }
      setHasMore(
        searchData["data"] && searchData["data"].length > 0 ? true : false
      );
    }
  }, [searchData]);
  const backButtonHandler = () => {
    navigate("/admin/dashboard", {
      replace: true,
      state: {
        selectedStudent: null,
      },
    });
  };
  const handleSetInputValue = (val: string) => {
    setInputValue(val);
    setOffSet(0);
  };
  const searchDataHandler = (searchterm: any, value?: any, keyName?: any) => {
    console.log("key value", keyName, value, inputValue);
    let url = `${BASE_URL + GLOBAL_SEARCH}`;
    url = url + `?name=${searchterm}`;
    url =
      url +
      "&moduleType=" +
      "faculty" +
      "&fexRole=Faculty,Academic Head,Regional Head";
    setSearchURL(url);
    const newUrl = url + "&limit=" + limit + "&offset=" + offset;
    GetSearchData(newUrl);
  };
  const nextHandler = () => {
    const newOffset = offset + limit;
    setOffSet((previous) => previous + limit);
    const url = searchURL + "&limit=" + limit + "&offset=" + newOffset;
    GetSearchData(url);
  };
  const onClickHandler = (newSuggest: any) => {
    handleSearchFaculty(newSuggest);
    setSelectedFaculty(newSuggest);
    setfilterState({
      ...filterState,
      email: newSuggest?.email,
      chipFieldName: {
        ...filterState.chipFieldName,
        email: newSuggest?.email,
      },
    });
    setOpen(false);
  };
  useEffect(() => {
    if (localStorage.getItem("myBatchsFilter")) {
      const parsedFilter = JSON.parse(
        localStorage.getItem("myBatchsFilter") as any
      );
      setfilterState({
        ...filterState,
        email: parsedFilter?.email,
        chipFieldName: {
          ...filterState.chipFieldName,
          email: parsedFilter?.email,
        },
      });
      if (parsedFilter) {
        setSearchName(parsedFilter.email);
        setInput(parsedFilter.email);
        setSelectedFaculty(parsedFilter.email);
      }
    }
  }, [localStorage.getItem("myBatchsFilter")]);
  const handleResetSearchfaculty = () => {
    localStorage.setItem("myBatchsFilter", "");
    handleSearchFaculty(null);
    setSelectedFaculty(null);
    setInput("");
    setdateNString(currentDate);
    setSelectedValue("plannedLectures");
    setOpen(false);
    setfilterState({
      email: null,
      plannedLecture: "plannedLectures",
      month: currentDate,
      chipFieldName: {
        month: currentDate,
        plannedLecture: "plannedLectures",
      },
    });
  };

  const { makeRequest: GetBatchCoursesChapterView } = useGetApi(
    (data) => {
      if (data && data["data"] && data["data"].length) {
        setBatchesData(setChapterHandler(BatchesData, data["data"]));
        setChapterData(data["data"]);
      } else {
        setChapterData([]);
      }
    },
    (error) => {
      setChapterData([]);
      if (
        error &&
        error["response"] &&
        error["response"]["data"] &&
        error["response"]["data"]["internalCode"] &&
        error["response"]["data"]["internalCode"] != "1008"
      ) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: error.message,
        });
      } else if (
        error &&
        error["response"] &&
        error["response"]["data"] &&
        error["response"]["data"]["code"] == "NF"
      ) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: "No record found",
        });
      }
    }
  );
  const onSelectedChange = (value: any) => {
    setSelectedValue(value);
    setfilterState({
      ...filterState,
      plannedLecture: value,
      chipFieldName: {
        ...filterState.chipFieldName,
        plannedLecture: value,
      },
    });
    if (value == "chapter") {
      if (chapterData.length) {
        setBatchesData(setChapterHandler(BatchesData, chapterData));
      } else {
        const arr = BatchesData.map((ele: any) => ele.plLecStatus)
          .filter((ele: any) => ele != null)
          .map((ele: any) => ele.batchCourseId);
        GetBatchCoursesChapterView(
          BASE_URL +
            GET_BATCH_COURSES_CHAPTER_VIEW +
            "?batchCourseIds=" +
            arr.toString()
        );
      }
    } else {
      setBatchesData(
        BatchesData.map((ele: any) => ({ ...ele, chapterData: null }))
      );
    }
    setOpen(false);
  };
  const onChange: DatePickerProps["onChange"] = (date, dateString) => {
    let mnth: any = "";
    let yr: any = "";
    if (typeof dateString === "string") {
      mnth = dayjs(date).get("month") + 1;
      const nyr = dateString.split("-")[1];
      yr = nyr.substring(2);
    }
    setdateNString(dateString);
    handleMonthYearFilter(mnth, yr);
    setOpen(false);
    setfilterState({
      ...filterState,
      month: dateString,
      chipFieldName: {
        ...filterState.chipFieldName,
        month: dateString,
      },
    });
  };
  const newFilterState = JSON.parse(JSON.stringify(filterState));
  const chipsFields = newFilterState && newFilterState.chipFieldName;

  delete newFilterState.chipFieldName;
  const onCloseHandler = (item: any) => {
    if (item === "plannedLecture") {
      setSelectedValue("plannedLectures");
      setfilterState((prevState: any) => ({
        ...prevState,
        plannedLecture: "plannedLectures",
        chipFieldName: {
          ...prevState.chipFieldName,
          plannedLecture: "plannedLectures",
        },
      }));
      setBatchesData(
        BatchesData.map((ele: any) => ({ ...ele, chapterData: null }))
      );
    } else if (item === "month") {
      setdateNString(currentDate);
      setfilterState((prevState: any) => ({
        ...prevState,
        month: currentDate,
        chipFieldName: {
          ...prevState.chipFieldName,
          month: currentDate,
        },
      }));
    } else {
      handleResetSearchfaculty();
    }
  };
  console.log(selectedFaculty);
  const checkIfFilterApplied = (filterSTATE: any, defaultVALUE: any) => {
    let retValue = false;
    Object.keys(defaultVALUE).map((el) => {
      if (defaultVALUE[el] != filterSTATE[el]) {
        retValue = true;
      }
    });
    return retValue;
  };
  const filterLength = Object.values(newFilterState).filter(
    (ele) => ele != null && ele != "plannedLecture"
  ).length;

  const Reset = () => <Button onClick={handleResetSearchfaculty}>Reset</Button>;

  return (
    <>
      <DrawerAntdComponent
        title={"Filters"}
        open={open}
        setOpen={setOpen}
        width={450}
        footer={
          <>
            <Space className="d-flex justify-content-end">
              {filterLength > 0 &&
              checkIfFilterApplied(filterState, defaultvalue) ? (
                <Reset />
              ) : null}
              <Button onClick={() => setOpen(false)}>Close</Button>
            </Space>
          </>
        }
      >
        <Form layout={"vertical"} className="w-100" size="middle">
          <StyledRow gutter={[10, 0]} screen={screen}>
            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
              <Form.Item label="Search">
                <AutoSearchInput
                  setInputValue={(val: string) => handleSetInputValue(val)}
                  setSuggestions={setSuggestions}
                  suggestions={suggestions}
                  isLoader={isLoader}
                  setIsLoader={setIsLoader}
                  searchData={searchDataHandler}
                  searchName={searchName}
                  setSearchName={setSearchName}
                  placeholder="Search by faculty email"
                  nextHandler={nextHandler}
                  hasMore={hasMore}
                  mode={"faculty_search"}
                  onClickHandler={onClickHandler}
                  input={input}
                  setInput={setInput}
                  width="100%"
                />
              </Form.Item>
            </Col>
            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
              <Form.Item label="Syllabus View">
                <Select
                  showSearch
                  value={selectedValue}
                  style={{ width: "100%" }}
                  size="middle"
                  options={[
                    {
                      label: "Planned Lectures",
                      value: "plannedLectures",
                    },
                    {
                      label: "Chapter",
                      value: "chapter",
                    },
                  ]}
                  onChange={onSelectedChange}
                />
              </Form.Item>
            </Col>

            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
              <Form.Item label="Syllabus Compliance Target Month">
                <DatePicker
                  // disabled={selectedValue == "chapter"}
                  onChange={onChange}
                  picker="month"
                  format={monthFormat}
                  style={{ width: "100%" }}
                  value={dayjs(dateNString, monthFormat)}
                  minDate={dayjs("2024-04-01", "YYYY-MM-DD")}
                />
              </Form.Item>
            </Col>
          </StyledRow>
        </Form>
      </DrawerAntdComponent>
      <HeadersComponent
        cardTitle={cardTitle}
        backButtonHandler={backButtonHandler}
      >
        <Space>
          {filterLength > 0 && ["xxl", "xl", "lg"].includes(screen) && (
            <ChipsTagsAntdComponent
              filterState={removeEmptyFields(newFilterState)}
              chipsFields={chipsFields}
              onCloseHandler={onCloseHandler}
              isShowCross={false}
            ></ChipsTagsAntdComponent>
          )}
          <Badge count={filterLength ? filterLength : 0}>
            <Button
              type="primary"
              onClick={() => {
                setOpen(true);
              }}
            >
              Filters
            </Button>
          </Badge>
          {filterLength > 0 &&
          checkIfFilterApplied(filterState, defaultvalue) ? (
            <Reset />
          ) : null}
        </Space>
      </HeadersComponent>
    </>
  );
};

export default MyBatchesHeaderAntd;
